// extracted by mini-css-extract-plugin
export default {"menuJoin":"c-a_eh","menuJoin_show":"c-a_ei"};